// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityNameQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EntityNameQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, household: { __typename?: 'Household', id: string }, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } };

export const Operations = {
  Query: {
    EntityName: 'EntityName' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const EntityNameDocument = gql`
    query EntityName($id: ID!) {
  entities(where: {id: $id}) {
    edges {
      node {
        id
        household {
          id
        }
        subtype {
          id
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useEntityNameQuery__
 *
 * To run a query within a React component, call `useEntityNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityNameQuery(baseOptions: Apollo.QueryHookOptions<EntityNameQuery, EntityNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityNameQuery, EntityNameQueryVariables>(EntityNameDocument, withFetchPolicyContext(options));
      }
export function useEntityNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityNameQuery, EntityNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityNameQuery, EntityNameQueryVariables>(EntityNameDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEntityNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityNameQuery, EntityNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityNameQuery, EntityNameQueryVariables>(EntityNameDocument, withFetchPolicyContext(options));
        }
export type EntityNameQueryHookResult = ReturnType<typeof useEntityNameQuery>;
export type EntityNameLazyQueryHookResult = ReturnType<typeof useEntityNameLazyQuery>;
export type EntityNameSuspenseQueryHookResult = ReturnType<typeof useEntityNameSuspenseQuery>;
export type EntityNameQueryResult = Apollo.QueryResult<EntityNameQuery, EntityNameQueryVariables>;